<template>
  <div class="noticiadetalhe">
    <div class="extensao_banner">
      <BreadCrumb :breadcrumb="breadcrumb" class="bcp" />
    </div>
    <div class="wrap" v-if="noticia != null">
      <div class="row">
        <Noticiabody :noticia="noticia" />
        <RecentMostViewedTab />
      </div>
      <div class="row linha_separador"></div>
    </div>
    <NoticiasPanel />
  </div>
</template>

<script>
import axios from "@/axios";
import { ref, onMounted } from "vue";
import { i18n } from "@/main.js";
import { useRoute,  onBeforeRouteLeave } from 'vue-router';
import BreadCrumb from "@/components/BreadCrumb.vue";
import RecentMostViewedTab from "@/components/noticia/RecentMostViewedTab.vue";
import Noticiabody from "@/components/noticia/Noticiabody.vue";
import NoticiasPanel from "@/components/noticia/NoticiasPanel.vue";
  

export default {
  components: {
    BreadCrumb,
    RecentMostViewedTab,
    Noticiabody,
    NoticiasPanel
  },
  setup() {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";

    //#region breadcrumb

    const breadcrumb = ref([]);
    onMounted(() => {
      breadcrumb.value = [
        { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
        { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
        { ID: 3, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
        { ID: 4, text: t("breadcrumb.sas"), route: { to: "/" } },
        { ID: 5, text: t("breadcrumb.noticias"), route: { to: "/noticiassas" } }
      ];
    })


    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    const route = useRoute();
    const noticia = ref(null);
    const recentTopNews = ref([]);
    

    const getNoticia = () => {
      axios.get(`/noticiassas/${route.params.id}?idioma=${lang}`)
      .then(response => {
          const secondaryImageKey = lang === "pt" ? 'noticia_imagemsecundaria' : 'noticia_imagemsecundariaEN';
          const secondaryImage = response.data[secondaryImageKey];
          const noticia_imagemsecundaria = secondaryImage ? 
            `${import.meta.env.VITE_APP_SITEURL}/wp-content/uploads/${secondaryImage}` :
            '';
          noticia.value = {
            ...response.data,
            noticia_imagemsecundaria
          };
          const updatedBreadcrumb = [
            ...breadcrumb.value,
            { ID: 6, text: response.data.post_title, href: "#" }
          ];
          breadcrumb.value = updatedBreadcrumb;
      })
      .catch(error => {
          console.log(error);
      });
    }

    getNoticia()

    return {
      noticia,
      breadcrumb
    }
  }
}
</script>

<style lang="scss" scoped>
.extensao_banner h1 {
  text-align: center;
  font-family: "Montserrat Bold";
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0, -10px, 0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 1024px) {
  .extensao_banner h1 {
    font-size: 40px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}

//#region detalhe

.noticiadetalhe {
  background-color: #f2f2f2;
}

.noticiadetalhe .wrap {
  padding-left: 10%;
  padding-right: 10%;
  max-width: 100%;
  margin: 0;
  padding-top: 160px;
}

.linha_separador {
  border-bottom: 1px solid #D3D3D3;
  padding-top: 75px;
  padding-bottom: 120px;
}

@media (max-width: 767px) {

  .noticiadetalhe .wrap {
    padding-top: 50px;
  }

  .linha_separador {
    padding-top: 60px;
    padding-bottom: 0;
    margin-bottom: 60px;
  }
}

//#endregion
</style>